var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import FilterDropdown from 'components/FilterDropdown';
import Checkboxes from './Checkboxes';
import Radios from './Radios';
import { SearchInput, ListWrap } from './styled';
var getContent = function (_a) {
    var isRadio = _a.isRadio, options = _a.options, value = _a.value, onChange = _a.onChange, onSearchChange = _a.onSearchChange;
    return (_jsxs(_Fragment, { children: [_jsx(SearchInput, { placeholder: "Search", onChange: onSearchChange, allowClear: true }), _jsx(ListWrap, { children: isRadio ? (_jsx(Radios, { options: options, onChange: onChange, value: value })) : (_jsx(Checkboxes, { options: options, onChange: onChange, value: value })) })] }));
};
var EnumFilteredDropdown = function (_a) {
    var _b = _a.isRadio, isRadio = _b === void 0 ? false : _b, defaultValue = _a.defaultValue, _c = _a.defaultTitle, defaultTitle = _c === void 0 ? 'Type' : _c, _d = _a.getReadableTitle, getReadableTitle = _d === void 0 ? function (v) { return v; } : _d, _e = _a.items, items = _e === void 0 ? [] : _e, onSave = _a.onSave, _f = _a.dataTest, dataTest = _f === void 0 ? 'EnumFilteredDropdown' : _f;
    var _g = useState(defaultValue
        ? "".concat(defaultTitle, ": ").concat(getReadableTitle(defaultValue))
        : defaultTitle), title = _g[0], setTitle = _g[1];
    var _h = useState(defaultValue), value = _h[0], setValue = _h[1];
    var _j = useState(), search = _j[0], setSearch = _j[1];
    var _k = useState([]), filteredItems = _k[0], setFilteredItems = _k[1];
    var _l = useState(Date.now()), resetKey = _l[0], setResetKey = _l[1];
    var onChange = function (e) {
        setValue(e);
    };
    var onResetTypes = function () {
        setTitle(defaultTitle);
        setValue(undefined);
        setSearch(undefined);
        onSave(undefined);
        setResetKey(Date.now());
    };
    var onSaveTypes = function () {
        setTitle("".concat(defaultTitle, ": ").concat(getReadableTitle(value)));
        onSave(value);
    };
    var onSearchChange = function (e) {
        setSearch(e.target.value);
    };
    useEffect(function () {
        if (filteredItems.length > 0 && search)
            // Not the actual filtering due to how checkbox group
            // works. Hiding the disabled items in css instead
            setFilteredItems(items.map(function (i) {
                if (i.label.toLowerCase().includes(search.toLowerCase()))
                    return i;
                return __assign(__assign({}, i), { disabled: true });
            }));
        if (!search)
            setFilteredItems(items);
        // eslint-disable-next-line
    }, [search, JSON.stringify(items), JSON.stringify(filteredItems)]);
    useEffect(function () {
        if (defaultValue && value) {
            setTitle("".concat(defaultTitle, ": ").concat(getReadableTitle(value || defaultValue)));
        }
        // eslint-disable-next-line
    }, [defaultValue, value]);
    var content = (_jsx("div", { children: getContent({
            isRadio: isRadio,
            options: filteredItems,
            value: value,
            onChange: onChange,
            onSearchChange: onSearchChange
        }) }, resetKey));
    return (_jsx(FilterDropdown, { title: title, content: content, hasDefaultValue: !!defaultValue, onSave: onSaveTypes, onReset: onResetTypes, dataTest: dataTest }));
};
export default EnumFilteredDropdown;
